import {
  put, takeLatest,
} from 'redux-saga/effects';
import { select } from '~/_shared/utils/saga/effects';
import { isNullsy } from '~/_shared/utils/typeGuards';
import {
  defaultBoundaryFillActivated,
  extraBoundaryFillActivated, extraBoundaryFillAdded, extraBoundaryFillUpdated,
} from '~/sidebar/sidebarApps/mapTools/boundary/extraFills/boundaryExtraFills.actionCreators';
import { boundaryTerritoryGroupsFetchDetailsRequest } from '~/store/boundaryTerritoryDetails/boundaryTerritoryDetails.actionCreators';
import { boundaryTerritoryGroupsWithActiveExtraFillSelector } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.selectors';
import type { FilterTreeItemRequest } from '~/store/spreadsheetData/filtering/spreadsheetDataFiltering.helpers';
import { getStoreFilterTree } from '~/store/spreadsheetData/filterTree/spreadsheetDataFilterTree.helpers';

export function* boundaryTerritoryExtraFillsSagas() {
  yield takeLatest([extraBoundaryFillAdded.type, extraBoundaryFillUpdated.type],
    loadBoundaryTerritoryFillDetailsAfterAddition);
  yield takeLatest([extraBoundaryFillActivated.type, defaultBoundaryFillActivated.type],
    loadBoundaryTerritoryFillDetailsAfterActivation);
}

function* loadBoundaryTerritoryFillDetailsAfterActivation(
  action: ReturnType<typeof extraBoundaryFillActivated>,
) {
  const { boundaryTerritoryGroupId } = action.payload;

  yield loadBoundaryTerritoryFillDetails(boundaryTerritoryGroupId);
}

function* loadBoundaryTerritoryFillDetailsAfterAddition(
  action: ReturnType<typeof extraBoundaryFillAdded>,
) {
  const { boundaryTerritoryGroupId } = action.payload;

  yield loadBoundaryTerritoryFillDetails(boundaryTerritoryGroupId, true);
}

function* loadBoundaryTerritoryFillDetails(boundaryTerritoryGroupId: number, forceRefresh: boolean = false) {
  const boundaryTerritoryGroupInfos: ReturnType<typeof boundaryTerritoryGroupsWithActiveExtraFillSelector> =
    yield select(boundaryTerritoryGroupsWithActiveExtraFillSelector);
  const currentCombinedFilterTrees: FilterTreeItemRequest | null = yield getStoreFilterTree();
  const currentDetailsFilterHash = currentCombinedFilterTrees?.filterHash ?? '';

  const boundaryTerritoryGroupInfo = boundaryTerritoryGroupInfos.find(
    groupInfo => groupInfo.boundaryTerritoryGroup.boundaryTerritoryGroupId === boundaryTerritoryGroupId,
  );
  if (!boundaryTerritoryGroupInfo) {
    return;
  }
  const lastActiveFillFilterHash = boundaryTerritoryGroupInfo.activeFillInfo?.filterHash;
  const activeFillNeedsRefresh = (
    (lastActiveFillFilterHash !== currentDetailsFilterHash) ||
    (isNullsy(boundaryTerritoryGroupInfo.activeFillInfo))
  );
  if (forceRefresh || activeFillNeedsRefresh) {
    yield put(boundaryTerritoryGroupsFetchDetailsRequest([boundaryTerritoryGroupInfo.boundaryTerritoryGroup]));
  }
}
